import React from "react";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import AdmissionUnit from "Admissions/routes/admissionUnit";
import UnitsAndSchools from "Admissions/routes/unitsAndSchools";
import { getAccountSetupPlaceholderRoutes } from "Admissions/routes/accountSetupPlaceholders";
import {
  ADMIN_PORTAL_POC_VARIANT,
  ADMIN_PORTAL_POC,
} from "Constants/adminPortalPocVariant";

const AdmissionsParent = ({ children }) =>
  React.createElement(React.Fragment, null, children);

// Bare /admissions has no unitId. AdmissionsRoot mounts the units query and
// replaces the URL with `/admissions/:firstUnitId`. Everything unit-scoped
// lives one level down in `routes/admissionUnit/`.
export default store => {
  // POC 1 mounts five common-setup placeholder routes as siblings of
  // `/admissions/unitsAndSchools`. They must come BEFORE AdmissionUnit
  // because AdmissionUnit's `path: ":unitId"` matches any path segment.
  const childRoutes = [UnitsAndSchools(store)];

  if (ADMIN_PORTAL_POC_VARIANT === ADMIN_PORTAL_POC.THREE_PORTALS) {
    childRoutes.push(...getAccountSetupPlaceholderRoutes());
  }

  childRoutes.push(AdmissionUnit(store));

  return {
    path: "admissions",
    // /admissions lives outside `/platform`, but the LMS-style GlobalHeader we
    // mount inside AdmissionsShell reads from `state.platform.*`. Inject the
    // Platform reducer lazily so those selectors resolve when a user enters
    // directly at an admissions URL.
    component: withAsyncRouteLoading(() =>
      import(
        /* webpackChunkName: "platform-reducer" */ "Platform/modules/PlatformModule"
      ).then(({ default: platformReducer }) => {
        injectReducer(store, { key: "platform", reducer: platformReducer });
        return AdmissionsParent;
      })
    ),
    indexRoute: {
      component: withAsyncRouteLoading(() =>
        import(
          /* webpackChunkName: "admissions-shell" */ "Admissions/features/Admissions/components/AdmissionsRoot"
        ).then(m => m.default)
      ),
    },
    childRoutes,
  };
};
